import { Alert,Badge,Button,Checkbox,Container,Group,NumberInput,Pagination,Table, Tabs, TextInput } from '@mantine/core';
import {  useViewportSize } from '@mantine/hooks';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { REACT_APP_UPLOADS } from '../../../../constants';

function DatasetManagementItems() {
    const { width, height } = useViewportSize();

    const [data, setData] = useState([]);

    const [totalElements, setTotalElements] = useState(611);

    const [totalPages, setTotalPages] = useState(62);

    const [page, setPage] = useState(1);

    const [size, setSize] = useState(10);

    const [species, setSpecies] = useState("");

    const [status, setStatus] = useState("");

    const [date, setDate] = useState("");

    const [species1, setSpecies1] = useState("");

    const [status1, setStatus1] = useState("");

    const [date1, setDate1] = useState("");

    const [running, setRunning] = useState(false);

    useEffect(() => {
      if(species === "" && status === "" && date === ""){
      axios.get(`${REACT_APP_UPLOADS}/api/v1/seizure-cases/all?page=${page-1}&size=${size}`, {
                headers: {
                  "ngrok-skip-browser-warning": "true"
                }
              }).then(function(res){
        if(res.data){
          //console.log(res.data);
          setData(res.data.content);
        }
      }).catch(function(err){
        console.log(err);
      });
      } else {
        setRunning(true);
        setData([]);
        axios.get(`${REACT_APP_UPLOADS}/api/v1/seizure-cases/filter?species=${species}&status=${status}&date=${date}`, {
                headers: {
                  "ngrok-skip-browser-warning": "true"
                }
              }).then(function(res){
        if(res.data){
          setData(res.data);
          setRunning(false);
          
        }
      }).catch(function(err){
        console.log(err);
        setRunning(false);
      });
      }
    }, [species, status, date, page, size])

  return (
    <Tabs defaultValue="trackedIncidents" color='green'>
      <Tabs.List>
        <Tabs.Tab value="trackedIncidents">Incidents on Track</Tabs.Tab>
        <Tabs.Tab value="reportedIncidents">Reported Incidents(Draft)</Tabs.Tab>
      </Tabs.List>


      <Tabs.Panel value="reportedIncidents" pt="xs">
        <div className='overflow-x-auto'>
        <Table striped highlightOnHover fontSize={"xs"} verticalSpacing="xs" horizontalSpacing="xs" style={{width: "100%"}}>
            <thead>
                <tr>
                <th style={{ whiteSpace: 'nowrap' }}>#</th>
                <th style={{ whiteSpace: 'nowrap' }}>Full Name</th>
                <th style={{ whiteSpace: 'nowrap' }}>Phone Number</th>
                <th style={{ whiteSpace: 'nowrap' }}>Email Address</th>
                <th style={{ whiteSpace: 'nowrap' }}>Location</th>
                <th style={{ whiteSpace: 'nowrap' }}>Level of Involvement</th>
                <th style={{ whiteSpace: 'nowrap' }}>Crime Types</th>
                <th style={{ whiteSpace: 'nowrap' }}>Agencies</th>
                <th style={{ whiteSpace: 'nowrap' }}>Description</th>
                <th style={{ whiteSpace: 'nowrap' }}>Actions</th>
                </tr>
            </thead>
            <tbody>
                  <tr>
                    <td style={{ textAlign: "center" }} colSpan={10}>
                        No records were found
                    </td>
                  </tr>
                </tbody>
        </Table>
        </div>
      </Tabs.Panel>

      <Tabs.Panel style={{ overflowX: "auto"}} value="trackedIncidents" pt="xs">
        <Container size={width * 0.75} h={height * 0.7}>
        <Group mb={10} position='apart' noWrap>
          <Group noWrap position='left'>
          <TextInput value={species1} onChange={(e) => {setSpecies1(e.currentTarget.value)}} label="Species" />
          <TextInput value={status1} onChange={(e) => {setStatus1(e.currentTarget.value)}} label="Case status" />
          <TextInput value={date1} onChange={(e) => {setDate1(e.currentTarget.value)}} label="Date of Seizure" />
            <Button loading={running} mt="lg" onClick={() => {
              setSpecies(species1);
              setDate(date1);
              setStatus(status1);
            }}>Run Filters</Button>
            <Button mt="lg" onClick={() => {
              setSpecies("");
              setDate("");
              setStatus("");

              setSpecies1("");
              setDate1("");
              setStatus1("");
            }} variant='default'>Clear Filters</Button>
          </Group>
          <NumberInput label="Size" value={size} onChange={(val: number) => {setSize(val)}} step={10} min={10} max={600} />
        </Group>
      <div style={{ overflowX: "auto", overflowY: "auto"}} className='overflow-x-auto'>
      <Table withBorder withColumnBorders highlightOnHover fontSize={"xs"} verticalSpacing="xs" horizontalSpacing="xs" style={{width: "100%"}}>
                          <thead>
                <tr>
                <th style={{ whiteSpace: 'nowrap' }}>#</th>
                <th style={{ whiteSpace: 'nowrap' }}>ID</th>
                <th style={{ whiteSpace: 'nowrap' }}>Case Status</th>
                <th style={{ whiteSpace: 'nowrap' }}>Date of Seizure</th>
                <th style={{ whiteSpace: 'nowrap' }}>Accused</th>
                <th style={{ whiteSpace: 'nowrap' }}>Nationality</th>
                <th style={{ whiteSpace: 'nowrap' }}>Gender</th>
                <th style={{ whiteSpace: 'nowrap' }}>Location</th>
                <th style={{ whiteSpace: 'nowrap' }}>Species</th>
                <th style={{ whiteSpace: 'nowrap' }}>Charge 1</th>
                <th style={{ whiteSpace: 'nowrap' }}>Charge 2</th>
                <th style={{ whiteSpace: 'nowrap' }}>Exhibit</th>
                <th style={{ whiteSpace: 'nowrap' }}>Weight</th>
                <th style={{ whiteSpace: 'nowrap' }}>Judgement Date</th>
                <th style={{ whiteSpace: 'nowrap' }}>Judgement Outcome</th>
                <th style={{ whiteSpace: 'nowrap' }}>Sentencing</th>
                </tr>
            </thead>
            <tbody>
              {data.map((itm: any, idx:any) => {
                return (
                  <tr key={idx}>
                    <td>
                        <Checkbox size="xs" />
                    </td>
                    <td>{idx+1}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>
                      <Badge>{itm?.caseStatus}</Badge>
                    </td>
                    <td style={{ whiteSpace: 'nowrap' }}>{itm?.dateOfSeizure}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{itm?.nameOfAccused}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{itm?.nationality}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{itm?.gender}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{itm?.location}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{itm?.species}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{itm?.charge1}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{itm?.charge2}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{itm?.exhibit}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{itm?.weight}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{itm?.judgementDate}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{itm?.judgementOutcome}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>{itm?.sentencing}</td>
                  </tr>
                )
              })}
                </tbody>
        </Table>
        </div>
        <Group position='right' mt={10}>
          <Pagination total={Math.floor(totalElements / size)} page={page} onChange={setPage} />
        </Group>
        </Container>
      </Tabs.Panel>


    </Tabs>
  );
}

export default function DatasetManagement(){
    return (
            <div className="space-y-8 p-6">
              {/* Interactive Map Section */}
              <section>
                <DatasetManagementItems />
              </section>
        
            </div>
    )
}